// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Va4pq","left":"styles_left__2ZCh_","desktopActions":"styles_desktopActions__3GpiG","title":"styles_title__2FukP"};